module.exports = __webpack_public_path__ + "static/media/icon_check_on.a1771afe.svg";